import {
  AfterViewInit,
  Component,
  ElementRef,
  Signal,
  signal,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { filter } from 'rxjs';
import { TextSizeMap } from '../../shared/constants/text-size-map.constant';
import { ImageDirective } from '../../shared/directives/ng-image.directive';
import { LegalTocService } from '../../shared/services/legal-toc.service';

@Component({
  selector: 'app-legal-layout',
  standalone: true,
  templateUrl: './legal-layout.component.html',
  imports: [
    RouterModule,
    NzIconModule,
    NzLayoutModule,
    NzMenuModule,
    ImageDirective,
    NzAnchorModule,
  ],
  styles: `
    ::ng-deep .ant-anchor-ink::before {
      @apply bg-gradient-to-b from-primary-500 to-primary-300;
    }

    ::ng-deep .ant-anchor-link {
      @apply !py-2;
    }

    ::ng-deep .ant-anchor-link-title {
      color: white;
    }

    ::ng-deep .ant-anchor-wrapper {
      @apply !max-h-fit;
    }

    ::ng-deep .ant-anchor .ant-anchor-link:last-child {
      @apply !mb-1;
    }
  `,
})
export class LegalLayoutComponent implements AfterViewInit {
  @ViewChild('scrollContainer', { read: ElementRef })
  scrollContainer!: ElementRef<HTMLElement>;

  protected readonly currentYear: number = new Date().getFullYear();
  protected readonly TextSizeMap = TextSizeMap;
  protected scrollEl: Signal<HTMLElement | null> = signal(null);

  constructor(
    protected toc: LegalTocService,
    private router: Router,
  ) {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        this.scrollContainer?.nativeElement?.scrollTo({ top: 0 });
      });
  }

  ngAfterViewInit(): void {
    const el = this.scrollContainer?.nativeElement;
    if (!el) return;
    (this.scrollEl as any).set(el);
  }

  scrollToSection(id: string): void {
    const el = this.scrollContainer?.nativeElement;
    const target = el?.querySelector<HTMLElement>(`#${id}`);
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
